import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {createTheme, ThemeProvider} from "@material-ui/core";
import LogRocket from 'logrocket';
LogRocket.init('aguwxa/uclusion-storefront');

const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1100,
        xl: 1536,
        // custom breakpoints:
        // desktop: 1100,
      },
    },
  });

const root = createRoot(document.getElementById('root'));
root.render(
    <React.Fragment>
        <ThemeProvider theme={theme}>
            <App campaign={new URLSearchParams(window.location.search).get('utm_campaign')}/>
        </ThemeProvider>
    </React.Fragment>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
